// Colors in this file are used for charts

/**
 * Brand approved colors
 */
export const colors = [
    '#054c70',
    '#05c3de',
    '#777777',
    '#e17a17',
    '#7d9845',
    '#614b79',
    '#38939b',
    '#ffdd00',
    '#3b3b3b',
    '#cecece',
    '#eaa15c',
    '#a4b67e',
    '#9181a0',
    '#74b4b9',
    '#ffe64e',
    '#898989',
    '#000000'
];

/**
 * creates an array of n size
 * using ^^colors and then looping
 * when exhausted to prevent
 * bugs due to undefined colors.
 */
export const createColorArray = (n) =>
    new Array(n).fill().map((_, i) => colors[i % colors.length]);

/**
 * Colors used for the comparison charts
 */
export const comparisonColors = ['#054c70', '#777777', '#cecece'];
